'use client'

import EnterViewAnimate from '@/components/enterView/animate'
import { Article } from '@/entities/article'
import { size } from 'lodash-es'
import 'swiper/css'
import { Autoplay, Pagination } from 'swiper/modules'
import { Swiper, SwiperSlide } from 'swiper/react'
import RecommendCard from './index'

export default function RecommendMainCard({ data }: { data: Article[] }) {
  return (
    <EnterViewAnimate animate='animate__fadeInLeft' className='relative'>
      <Swiper
        modules={[Pagination, Autoplay]}
        pagination={{
          clickable: true,
          enabled: size(data) > 1,
          el: '#insights-recommend-pagination',
          bulletClass:
            'w-4 h-4 lg:w-7.5 lg:h-7.5 bg-white rounded-full grid place-items-center cursor-pointer text-font-primary/0 lg:text-font-primary',
          bulletActiveClass: '!bg-primary lg:text-white',
          renderBullet: function (index, className) {
            return '<span class="' + className + '">' + (index + 1) + '</span>'
          },
        }}
        autoplay={{ pauseOnMouseEnter: true }}
        spaceBetween={20}
        className='w-full h-full'
      >
        {data.map((item) => (
          <SwiperSlide key={item.id}>
            <RecommendCard data={item} />
          </SwiperSlide>
        ))}
      </Swiper>
      {size(data) > 1 && (
        <div
          id='insights-recommend-pagination'
          className='absolute top-5 left-5 z-10 flex items-center gap-x-2 lg:gap-x-4'
        ></div>
      )}
    </EnterViewAnimate>
  )
}
